<aw-theme context="shop" mode="auto">
  @if (configurationStore.configuration() && !configurationStore.isLoading()) {
    <div
      class="flex min-h-screen flex-col overflow-x-hidden"
      [ngStyle]="{
        background: corporateDesignService.isDarkModeActive() ? '#121212' : '',
      }">
      <aw-header [attr.data-testid]="'header-container'" />
      <main class="flex max-w-full flex-1 justify-center">
        <div class="h-content w-full max-w-[1440px]">
          <router-outlet></router-outlet>
        </div>
        <aw-snackbar></aw-snackbar>
      </main>
      <aw-footer [attr.data-testid]="'footer-container'"></aw-footer>
    </div>
  }
</aw-theme>